import { useIncorporationWizardFormCtx } from "../../hooks/IncorporationWizardFormContext";

export default function NextButton({
  label = "Next",
  className,
  style,
  disabled,
  onClick,
  type = "button",
}: {
  label?: string;
  className?: string;
  style?: React.CSSProperties;
  disabled?: boolean;
  onClick?: () => void;
  type?: "button" | "submit";
}) {
  const { canNext, next } = useIncorporationWizardFormCtx();
  
  const handleClick = () => {
    if (type === "submit") {
      // Submit buttons trigger form submission
      // Don't call next() - form's onSubmit handles navigation
      onClick?.();
      return;
    }
    
    // Regular button behavior
    if (canNext) {
      if (onClick) {
        onClick();
        return;
      } 
      next();
    }
  };
  
  return (
    <button
      type={type}
      disabled={disabled}
      className={`btn btn-black w-100 mt-3 ${className}`}
      style={style}
      onClick={handleClick}
    >
      {label}
    </button>
  );
}